import DocumentTypeForm from "./DocumentTypeForm";

const AddDocumentTypeForm = ({ isLoading, onSubmit, onCloseClicked }) => {
  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-auto md:min-w-[600px] pb-1">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Add document type</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <DocumentTypeForm isLoading={isLoading} onSubmit={onSubmit} />
    </div>
  )
}

export default AddDocumentTypeForm;
